module.exports = __webpack_public_path__ + "media/images/responsive/keywords/keyword_chapel-b549a5749434561aeab28ec44ed50425.jpg";